<div class="app-visualization-component" fxLayout="column" fxFlex>
    @if (
        visualization?.comparationsValues?.length &&
        hasValidData() &&
        visualization.props?.component?.name !== "METRIC_KPI"
    ) {
        <app-indicator-values
            [company]="company"
            [visualization]="visualization"
            [options]="options"
            [points]="points"
            [series]="series"
            [isDrilldown]="isDrilldown"
            [style.height]="isDrilldown ? '100%' : '56px'"
            [suffix]="suffixIndicatorValues"
        ></app-indicator-values>
    }
    <div
        [style.height]="
            visualization?.comparationsValues?.length &&
            hasValidData() &&
            !absoluteChartArea
                ? 'calc(100% - 56px)'
                : '100%'
        "
        [class.app-visualization-component--absolute-chart-area]="
            absoluteChartArea
        "
        fxLayout="column"
        fxFlex
    >
        @if (!hasValidData() && !loading && !visualization.isDrilldown) {
            <div
                fxLayout="column"
                fxLayoutAlign="center center"
                class="gap-16"
                fxFlex
            >
                @if (isMobile()) {
                    <img
                        src="/images/empty-indicator.svg"
                        width="100px"
                        height="100px"
                        alt=""
                    />
                } @else {
                    <img
                        src="/images/empty-indicator.svg"
                        width="128.05px"
                        height="128.05ps"
                        alt=""
                    />
                }
                <div
                    class="visualization__empty-state-text"
                    style="max-width: 210px; width: 210px"
                    fxLayout="column"
                    fxLayoutAlign="center center"
                >
                    <p
                        class="text-center color-text-medium  {{
                            isMobile()
                                ? 'text-12-semi-bold'
                                : 'text-16-semi-bold'
                        }}"
                    >
                        Não há dados disponíveis deste período.
                    </p>
                </div>
            </div>
        } @else {
            @if (visualization.props?.component?.name) {
                <div class="full-height" fxLayout="column" fxFlex>
                    <app-special-chart-render
                        style="height: 100%"
                        [componentName]="visualization.props?.component?.name"
                        [data]="{
                            visualization,
                            series,
                            points,
                            options,
                            company
                        }"
                    ></app-special-chart-render>
                </div>
            } @else if (visualization.props.historic) {
                <app-chart-historic
                    [loading]="loading"
                    [options]="options"
                    [visualization]="visualization"
                    [series]="series"
                    [points]="points"
                    [company]="company"
                ></app-chart-historic>
            } @else {
                <app-highcharts-render
                    class="full-height"
                    [loading]="loading"
                    [options]="options"
                    [visualization]="visualization"
                    [series]="series"
                    [points]="points"
                    [company]="company"
                ></app-highcharts-render>
            }
        }
    </div>
</div>
